import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetDeviceTreeResData } from "./GetDeviceTreeResData";
import { SearchFilter } from "./SearchDevicesReqData";

const ENDPOINT = "/device/search";

export class SearchDevicesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: Object = null;

    constructor(payload: SearchFilter) {
        super();
        this.payload = JSON.parse(JSON.stringify(payload));
        if (payload.installationName != null && payload.installationName != undefined) {
            this.payload["installationNames"] = payload.installationName
                .trim()
                .split(" ")
                .map((element) => element.trim())
                .filter((element) => element !== "");
        }
        if (payload.machinesSerialNumber != null && payload.machinesSerialNumber != undefined) {
            this.payload["machinesSerialNumber"] = payload.machinesSerialNumber
                .trim()
                .split(",")
                .map((element) => element.trim())
                .filter((element) => element !== "");
        }
        this.payload["tag.tagName"] = payload.tag.tagName;
        this.payload["tag.availableValues"] = payload.tag.availableValues;
    }

    public async execute(): Promise<GetDeviceTreeResData> {
        var res = await this.executeCommand(this.payload);
        return new GetDeviceTreeResData(res);
    }
}
